import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { KILO } from '../../constants/KILO_THEME'
import BentoCard from '../ui/BentoCard'
import MaterialIcon from '../ui/MaterialIcon'

type AuthShellProps = {
  children: ReactNode
  title: string
  subtitle?: string
  icon?: string
  footer?: ReactNode
}

const AuthShell = ({ children, title, subtitle, icon = 'fitness_center', footer }: AuthShellProps) => {
  const { t } = useTranslation()

  return (
    <div className={`min-h-screen ${KILO.bg.page} ${KILO.text.primary}`}>
      <div className="mx-auto flex min-h-screen max-w-lg flex-col justify-center px-4 py-10 sm:py-12">
        <header className="mb-6 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-kilo-border bg-kilo-card ring-1 ring-kilo-accent/25">
            <MaterialIcon name={icon} filled size="xl" />
          </div>
          <p className={KILO.meta}>{t('common.brand')}</p>
          <h1 className={`mt-2 text-3xl ${KILO.heading}`}>{title}</h1>
          {subtitle ? <p className={`mt-2 text-sm leading-relaxed ${KILO.text.muted}`}>{subtitle}</p> : null}
        </header>

        <BentoCard gradient="slate" featured className="p-5 sm:p-6">
          {children}
        </BentoCard>

        {footer ? <div className="mt-6 text-center">{footer}</div> : null}
      </div>
    </div>
  )
}

export default AuthShell
